class CartNotification extends HTMLElement {
  constructor() {
    super();

    this.notification = document.getElementById('cart-notification');
    this.header = document.querySelector('sticky-header');
    this.onBodyClick = this.handleBodyClick.bind(this);

    this.notification.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.querySelectorAll('button[type="button"]').forEach((closeButton) =>
      closeButton.addEventListener('click', this.close.bind(this))
    );
  }

  open() {
    this.notification.classList.add('animate', 'active');

    this.notification.addEventListener(
      'transitionend',
      () => {
        this.notification.focus();
        trapFocus(this.notification);
      },
      { once: true }
    );

    document.body.addEventListener('click', this.onBodyClick);
  }

  close() {
    this.notification.classList.remove('active');
    document.body.removeEventListener('click', this.onBodyClick);

    removeTrapFocus(this.activeElement);
  }

  renderContents(parsedState) {
    if (parsedState.key) {
      this.cartItemKey = parsedState.key;
    } else {
      this.cartItemKey = 'undefined';
    }

    this.getSectionsToRender().forEach((section) => {
      document.getElementById(section.id).innerHTML = parsedState.sections[section.id];
    });

    // update free shipping progress bar using the live cart
    this.updateFreeShippingBar();

    if (this.header) {
      this.header.reveal();
    }

    this.open();
  }

  updateFreeShippingBar() {
    const wrapper = this.querySelector('[data-free-shipping-wrapper]');
    if (!wrapper) return;

    const threshold = Number(wrapper.dataset.freeShippingThreshold || 0);

    // Get the latest cart values from /cart.js
    fetch('/cart.js')
      .then((response) => response.json())
      .then((cart) => {
        if (!cart) return;

        const subtotal = Number(
          cart.items_subtotal_price !== undefined
            ? cart.items_subtotal_price
            : cart.total_price !== undefined
            ? cart.total_price
            : 0
        );

        const remaining = Math.max(threshold - subtotal, 0);
        const progress = threshold > 0 ? Math.min((subtotal / threshold) * 100, 100) : 0;

        const barFill = wrapper.querySelector('[data-free-shipping-bar-fill]');
        const textEl = wrapper.querySelector('.cart-notification__free-shipping-text');

        if (barFill) {
          barFill.style.width = `${progress}%`;
        }

if (textEl) {
  if (remaining <= 0) {
    textEl.textContent = 'You have unlocked free shipping';
  } else {
    const currencySymbol = wrapper.dataset.currencySymbol || '';
    if (typeof Shopify !== 'undefined' && typeof Shopify.formatMoney === 'function') {
      textEl.textContent = `Spend ${Shopify.formatMoney(remaining)} more for free shipping`;
    } else {
      const amount = (remaining / 100).toFixed(2);
      textEl.textContent = `Spend ${currencySymbol}${amount} more for free shipping`;
    }
  }
}

      })
      .catch((error) => {
        console.error('Error updating free shipping bar', error);
      });
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-notification-product',
        selector: `[id="cart-notification-product-${this.cartItemKey}"]`,
      },
      {
        id: 'cart-notification-button',
      },
      {
        id: 'cart-icon-bubble',
      },
    ];
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
  }

  handleBodyClick(evt) {
    const target = evt.target;
    if (target !== this.notification && !target.closest('cart-notification')) {
      const disclosure = target.closest('details-disclosure, header-menu');
      this.activeElement = disclosure ? disclosure.querySelector('summary') : null;
      this.close();
    }
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('cart-notification', CartNotification);
